<!-- src/app/views/prueba-informativa/dialog-form-prueba-informativa/dialog-form-prueba-informativa.component.html -->
<app-button-close-dialog></app-button-close-dialog>
<h2 mat-dialog-title>Acción realizada :: <strong>{{ data.accion == accionesDialog.Agregar ? 'Crear' : data.accion ==
    accionesDialog.Eliminar ? 'Eliminar': data.accion == accionesDialog.Ver
    ? 'Ver' : 'Modificar' }} Prueba Informativa</strong></h2>

<!-- Spinners para diferentes operaciones -->
<ngx-spinner [zIndex]="100" name="spCrearPruebaInformativa" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<ngx-spinner [zIndex]="100" name="spModificarPruebaInformativa" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<ngx-spinner [zIndex]="100" name="spEliminarPruebaInformativa" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion != accionesDialog.Ver">

  <form [formGroup]="form">
    <ng-container *ngIf="data.accion == accionesDialog.Eliminar; else formTemplate">
      <div class="delete-confirmation">
        <mat-icon class="warning-icon">warning</mat-icon>
        <p>¿Está seguro que desea eliminar la prueba informativa <strong>{{data.descripcion}}</strong>?</p>
        <p class="delete-warning">Esta acción no se puede deshacer.</p>
      </div>
    </ng-container>

    <ng-template #formTemplate>
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" dynamicHeight  >

        <!-- Tab 1: Información Básica -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">info</mat-icon>
            Información Básica
          </ng-template>

          <mat-card>
            <mat-card-header>
              <div mat-card-avatar>
                <mat-icon>title</mat-icon>
              </div>
              <mat-card-title>Gestión de Audiencia Confesional</mat-card-title>
              <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Descripción</mat-label>
                    <input placeholder="Descripción de la prueba informativa" type="text" formControlName="Descripcion"
                      matInput />
                    <mat-error *ngIf="f.Descripcion.errors?.['required']">Este campo es
                      <strong>requerido</strong>.</mat-error>
                    <mat-error *ngIf="f.Descripcion.errors?.['maxlength']">Máximo 500 caracteres.</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Domicilio</mat-label>
                    <input placeholder="Domicilio relacionado" type="text" formControlName="Domicilio" matInput />
                    <mat-error *ngIf="f.Domicilio.errors?.['maxlength']">Máximo 300 caracteres.</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Informa Sobre</mat-label>
                    <textarea placeholder="Información detallada sobre el tema" formControlName="InformaSobre" matInput
                      rows="4"></textarea>
                    <mat-error *ngIf="f.InformaSobre.errors?.['required']">Este campo es
                      <strong>requerido</strong>.</mat-error>
                    <mat-error *ngIf="f.InformaSobre.errors?.['maxlength']">Máximo 1000 caracteres.</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Observaciones</mat-label>
                    <textarea placeholder="Observaciones adicionales" formControlName="Observaciones" matInput
                      rows="3"></textarea>
                    <mat-error *ngIf="f.Observaciones.errors?.['maxlength']">Máximo 1000 caracteres.</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </mat-tab>

        <!-- Tab 2: Personas Involucradas -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">people</mat-icon>
            Personas
          </ng-template>

          <mat-card>
            <mat-card-header>
              <div mat-card-avatar>
                <mat-icon>person</mat-icon>
              </div>
              <mat-card-title> Datos Informante</mat-card-title>
              <mat-card-subtitle>Información basica</mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>
              <div class="row">
                <div class="col-sm-12">
                  <app-buscar-persona [personaEntrada]="personaInformanteSeleccionada" [disable]="false"
                    nombre="Informante" (eventEntity)="onPersonaInformanteSelected($event)">
                  </app-buscar-persona>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <ngx-spinner [zIndex]="-1" name="spBusquedaUsuarios" bdColor="rgba(255,255,255,0.8)" size="small"
                      color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                    <mat-label>Usuario Responsable</mat-label>
                    <mat-select placeholder="Seleccione un usuario" formControlName="IdUsuarioResponsable">
                      <mat-option [value]="usuario.id"
                        *ngFor="let usuario of usuarios; let i = index; trackBy: trackByItems">
                        {{ usuario.nombre }} {{ usuario.apellido }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="f.IdUsuarioResponsable.errors?.['required']">Este campo es
                      <strong>requerido</strong>.</mat-error>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <ngx-spinner [zIndex]="-1" name="spBusquedaTiposIntervinientes" bdColor="rgba(255,255,255,0.8)"
                      size="small" color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                    <mat-label>Tipo de Interviniente</mat-label>
                    <mat-select placeholder="Seleccione un tipo" formControlName="IdTipoInterviniente">
                      <mat-option [value]="tipo.id"
                        *ngFor="let tipo of tiposIntervinientes; let i = index; trackBy: trackByItems">
                        {{ tipo.descripcion }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <ngx-spinner [zIndex]="-1" name="spBusquedaEstados" bdColor="rgba(255,255,255,0.8)" size="small"
                      color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                    <mat-label>Estado de Prueba</mat-label>
                    <mat-select placeholder="Seleccione un estado" formControlName="IdEstadoPrueba">
                      <mat-option [value]="estado.id"
                        *ngFor="let estado of estadosPrueba; let i = index; trackBy: trackByItems">
                        {{ estado.descripcion }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </mat-tab>

        <!-- Tab 3: Fechas de Oficios -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">event</mat-icon>
            Fechas de Oficios
          </ng-template>

          <mat-card>
            <mat-card-header>
              <div mat-card-avatar>
                <mat-icon>evet</mat-icon>
              </div>
              <mat-card-title> Gestión de Oficios</mat-card-title>
              <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha Oficio Confronte</mat-label>
                    <input matInput [matDatepicker]="pickerConfronte" formControlName="FechaOficioConfronte"
                      placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerConfronte"></mat-datepicker-toggle>
                    <mat-datepicker #pickerConfronte></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha Oficio Retirado</mat-label>
                    <input matInput [matDatepicker]="pickerRetirado" formControlName="FechaOficioRetirado"
                      placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerRetirado"></mat-datepicker-toggle>
                    <mat-datepicker #pickerRetirado></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha Oficio Diligenciado</mat-label>
                    <input matInput [matDatepicker]="pickerDiligenciado" formControlName="FechaOficioDiligenciado"
                      placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerDiligenciado"></mat-datepicker-toggle>
                    <mat-datepicker #pickerDiligenciado></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha Oficio Contestado</mat-label>
                    <input matInput [matDatepicker]="pickerContestado" formControlName="FechaOficioContestado"
                      placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerContestado"></mat-datepicker-toggle>
                    <mat-datepicker #pickerContestado></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha Vence Contestación</mat-label>
                    <input matInput [matDatepicker]="pickerVence" formControlName="FechaVenceContestacion"
                      placeholder="Seleccione fecha">
                    <mat-datepicker-toggle matSuffix [for]="pickerVence"></mat-datepicker-toggle>
                    <mat-datepicker #pickerVence></mat-datepicker>
                    <mat-hint>Fecha límite para recibir contestación</mat-hint>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </mat-tab>

      </mat-tab-group>
    </ng-template>
  </form>

</mat-dialog-content>

<!-- Vista de solo lectura -->
<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion == accionesDialog.Ver">
  <div *ngIf="data">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" dynamicHeight>

      <!-- Tab 1: Información General -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">info</mat-icon>
          General
        </ng-template>

        <mat-card>
          <mat-card-header>
            <div mat-card-avatar>
              <mat-icon>title</mat-icon>
            </div>
            <mat-card-title>Información Básica</mat-card-title>
            <mat-card-subtitle></mat-card-subtitle>
          </mat-card-header>

          <mat-card-content>
            <div class="property-row">
              <span class="property-name">Descripción:</span>
              <span class="property-value">{{ data.descripcion | titlecase }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Domicilio:</span>
              <span class="property-value">{{ data.domicilio | titlecase }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Observaciones:</span>
              <span class="property-value">{{ data.observaciones | titlecase }}</span>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>Información Detallada</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row">
              <span class="property-name">Informa Sobre:</span>
              <div class="property-value">{{ data.informaSobre }}</div>
            </div>
          </mat-card-content>
        </mat-card>
      </mat-tab>

      <!-- Tab 2: Personas -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">people</mat-icon>
          Personas
        </ng-template>

        <mat-card appearance="outlined">
          <mat-card-header>
            <div mat-card-avatar>
                <mat-icon>person</mat-icon>
              </div>
            <mat-card-title>Personas Involucradas</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row">
              <span class="property-name">Persona Informante:</span>
              <span class="property-value">{{ data.personaInformante?.nombreCompleto | titlecase }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Usuario Responsable:</span>
              <span class="property-value">{{ data.usuarioResponsable?.nombreCompleto | titlecase }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Tipo Interviniente:</span>
              <span class="property-value">{{ data.tipoInterviniente?.descripcion | titlecase }}</span>
            </div>
          </mat-card-content>
        </mat-card>
      </mat-tab>

      <!-- Tab 3: Fechas de Oficios -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">event</mat-icon>
          Fechas de Oficios
        </ng-template>

        <mat-card appearance="outlined">
          <mat-card-header>
            <div mat-card-avatar>
                <mat-icon>event</mat-icon>
              </div>
            <mat-card-title>Gestión de Oficios</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row">
              <span class="property-name">Fecha Oficio Confronte:</span>
              <span class="property-value">{{ data.fechaOficioConfronte | date:'dd/MM/yyyy' }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Fecha Oficio Retirado:</span>
              <span class="property-value">{{ data.fechaOficioRetirado | date:'dd/MM/yyyy' }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Fecha Oficio Diligenciado:</span>
              <span class="property-value">{{ data.fechaOficioDiligenciado | date:'dd/MM/yyyy' }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Fecha Oficio Contestado:</span>
              <span class="property-value">{{ data.fechaOficioContestado | date:'dd/MM/yyyy' }}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Fecha Vence Contestación:</span>
              <span class="property-value">{{ data.fechaVenceContestacion | date:'dd/MM/yyyy' }}</span>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- Información de Auditoría -->
        <div *ngIf="data.fechaAlta || data.fechaModificacion">
          <mat-card appearance="outlined">
            <mat-card-header>
              <div mat-card-avatar>
                <mat-icon>visibility</mat-icon>
              </div>
              <mat-card-title>Información de Auditoría</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div class="property-row">
                    <span class="property-name">Fecha de Alta:</span>
                    <span class="property-value">{{ data.fechaAlta | date:'dd/MM/yyyy HH:mm' }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Creado por:</span>
                    <span class="property-value">{{ data.creadoPor?.descripcion || 'Sistema' }}</span>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="property-row">
                    <span class="property-name">Última Modificación:</span>
                    <span class="property-value">{{ data.fechaModificacion | date:'dd/MM/yyyy HH:mm' }}</span>
                  </div>
                  <div class="property-row">
                    <span class="property-name">Modificado por:</span>
                    <span class="property-value">{{ data.modificadoPor?.descripcion }}</span>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-tab>

    </mat-tab-group>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <app-button-cancel-dialog></app-button-cancel-dialog>

  <app-button-add *ngIf="data.accion == accionesDialog.Agregar" [disabled]="!form.valid" (click)="agregar()">
  </app-button-add>

  <app-button-save *ngIf="data.accion == accionesDialog.Modificar" [disabled]="!form.valid" [isDialogClose]="true"
    (saveClicked)="modificar()" (cancelClicked)="closeDialog()">
  </app-button-save>

  <app-button-delete *ngIf="data.accion == accionesDialog.Eliminar" (click)="eliminar()" (cancelClicked)="closeDialog()"
    [isDialogClose]="true">
  </app-button-delete>
</mat-dialog-actions>
